import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { AlertButton, IonAlert } from '@ionic/angular/standalone';
import { OverlayEventDetail } from '@ionic/core/components';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.css'],
	imports: [IonAlert, TranslatePipe],
    standalone: true,
})
export class ConfirmationDialogComponent implements OnInit {
    private readonly translateService: TranslateService = inject(TranslateService);

    public confirmationButtons: AlertButton[] = [];

	@Input({required: true}) trigger!: string;
	@Input() header?: string;
	@Input() message?: string;
	@Input({required: true}) confirmTextKey!: string;
	@Input({required: true}) cancelTextKey!: string;

	@Output() confirmed = new EventEmitter<void>();

    constructor() {}

    ngOnInit() {
        this.initializeConfirmationButtons();
    }

    private initializeConfirmationButtons() {
        this.configureConfirmationButtons();

        this.translateService.onLangChange.subscribe(() => {
            this.configureConfirmationButtons();
        });
    }

    private configureConfirmationButtons() {
        const cancelText = this.translateService.instant(this.cancelTextKey);
        const confirmText = this.translateService.instant(this.confirmTextKey);

        this.confirmationButtons = [
            {
                text: cancelText,
                role: 'cancel',
                cssClass: 'cancelButton',
            },
            {
                text: confirmText,
                role: 'confirm',
                cssClass: 'confirmButton',
            },
        ];
    }

    public onConfirmationAlertDismiss(event: CustomEvent<OverlayEventDetail>) {
        if (event.detail.role === 'confirm') {
            this.confirmed.emit();
        }
    }
}
